module.exports = __webpack_public_path__ + "02_long_yellow.8293516e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_long_yellow.png
// module id = Egrc
// module chunks = 0